import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withKeys as _withKeys, mergeProps as _mergeProps, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3ba5260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-start mb-5" }
const _hoisted_2 = { class: "p-3 w-full bg-white flex flex-row align-items-center justify-between w-100" }
const _hoisted_3 = { class: "align-items-center d-flex font-weight-bold pl-3" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center gap-4"
}
const _hoisted_5 = { class: "wrapper-sign-out relative" }
const _hoisted_6 = {
  key: 0,
  class: "w-full"
}
const _hoisted_7 = ["href", "onClick", "onKeydown"]

import TabMenu from "primevue/tabmenu";
import LogoProject from "@/components/videntity/LogoProject.vue";
import { modulesSystem } from "@/constants";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import routes from "@/router/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarTop',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const currentRouteName = route.name;

const store = useStore();

const auth = computed(() => store.state.auth);
const authUser = computed(() => store.state.profile);

const signOut = () => store.dispatch("SIGN_OUT");
const showMenu = ref(false);
const menuRef = ref<HTMLElement | null>(null);

const active = computed({
  set(val) {
    // store.commit("SET_CURRENT_TAB", val);
  },
  get() {
    return store.state.currentTab;
  },
});

const itemsRoutesRaw = routes
  .filter((f: any) => f.meta?.ShowNav)
  .map((f) => {
    return {
      label: f.meta?.title,
      route: f.path,
      navBarTab: f?.meta?.navBarTab,
      modulesNeeded: f?.meta?.modulesNeeded?.[0] ?? null,
    };
  })
  .sort((a, b) => a.navBarTab - b.navBarTab);

const itemsRoutes = computed(() =>
  itemsRoutesRaw.map((v: any) => {
    if (v.modulesNeeded && !authUser.value?.modules[v?.modulesNeeded]?.read) {
      v.disabled = true;
    } else {
      v.disabled = false;
    }
    return v;
  })
);

const handleClickOutside = (event: MouseEvent) => {
  console.log(event.target, menuRef.value);
  if (menuRef.value && !menuRef.value.contains(event.target as Node)) {
    showMenu.value = false;
    removeClick();
  }
};

function toggleMenu() {
  showMenu.value = !showMenu.value;
  setTimeout(() => addClick(), 200);
}

onBeforeUnmount(() => {
  removeClick();
});
function addClick() {
  document.addEventListener("click", handleClickOutside);
}
function removeClick() {
  document.removeEventListener("click", handleClickOutside);
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LogoProject, { "title-size": "md" }),
      _createElementVNode("div", _hoisted_3, [
        (auth.value?.login)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleMenu())),
                  title: "configurações",
                  class: "pi pi-cog cursor-pointer text-[22px]"
                }),
                (showMenu.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref_key: "menuRef",
                      ref: menuRef,
                      class: "absolute right-[0px] top-0 bg-white p-2 w-[150px] shadow-lg"
                    }, [
                      _createVNode(_component_router_link, {
                        to: "/profile",
                        class: "d-flex align-items-center justify-content-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            class: "btn-simple w-full p-2 hover:!text-black",
                            icon: "pi pi-cog",
                            label: "Editar perfil"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/profile",
                        class: "d-flex align-items-center justify-content-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            class: "btn-simple w-full p-2 mt-2 hover:!text-black",
                            icon: "pi pi-sign-out",
                            label: "Sair",
                            onClick: signOut
                          })
                        ]),
                        _: 1
                      })
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/login"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Login ")
              ]),
              _: 1
            }))
      ])
    ]),
    (auth.value?.login)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(TabMenu), {
            activeIndex: active.value,
            "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
            model: itemsRoutes.value,
            class: "mb-2"
          }, {
            item: _withCtx(({ label, item, props }) => [
              (item.route)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.route,
                    class: "h-100"
                  }, {
                    default: _withCtx((routerProps) => [
                      _createElementVNode("a", _mergeProps({
                        href: routerProps.href
                      }, props.action, {
                        onClick: ($event) => routerProps.navigate($event),
                        onKeydown: _withKeys(($event) => routerProps.navigate($event), ["enter","space"])
                      }), [
                        _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(label), 17)
                      ], 16, _hoisted_7)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["activeIndex", "model"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})